import { useRemoteConfigValue } from '../../../../shared/remote-config/ui/useRemoteConfigValue';
import { CheckpointQueueAccessType } from '../../../domain/models/CheckpointQueueAccessType';

export function useAvailableAccessTypes() {
	const { value: isPriorityEnabled } = useRemoteConfigValue(
		'security_filter_priority_enabled',
	);

	const accessTypes = Object.values(CheckpointQueueAccessType);

	if (isPriorityEnabled === true) {
		return accessTypes;
	}

	return accessTypes.filter(
		(accessType) => accessType !== CheckpointQueueAccessType.Priority,
	);
}
